import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { GlobalSettingsService } from '../globalSettings.service';
import { loginPath } from 'assets/consts';
import { Utils } from '@shared/utils.service';
import { ModalIcon, ModalKeys, NotificationService } from '@shared/notification/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { PlatformLoginService } from 'app/services/platform-login/platform-login.service';
import { FeatureToggle } from '@shared/enums';
import { FeaturesToggleSettingsService } from '../../featuresToggleSettings/service/featuresToggleSettings.service';
import { PlatformAccessService } from 'app/services/platform-access/platform-access.service';
import { firstValueFrom } from "rxjs";
import { Platform } from "@nodeModules/@itero/itero-platform-login";

@Injectable()
export class RolesGuard  {
	constructor(
		private globalSettings: GlobalSettingsService,
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private router: Router,
		private utils: Utils,
		private readonly platformLoginService: PlatformLoginService,
		private readonly featuresToggleSettingsService: FeaturesToggleSettingsService,
		private readonly platformAccessService: PlatformAccessService,
	) {}

	async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
		const settings = this.globalSettings.get();
		const expectedRoles = route.data.expectedRoles;
		if (settings || route.data.allowAnonymous) {
			if (route.data.allowAnonymous || (expectedRoles && expectedRoles.indexOf(settings.roleType) > -1)) {
				const useIteroPlatformLogin = await firstValueFrom(this.featuresToggleSettingsService.isVisibleFeature$(FeatureToggle.UseIteroPlatformLogin));
				return useIteroPlatformLogin && this.platformLoginService.iteroPlatformLoginUsed() ? await this.platformAccessService.verifyOrRedirect(Platform.Midc) : true;
			} else {
				const urlPath = this.utils.getUrlPath(this.router.url);
				const isLoginPageAndRoleChanged =
					urlPath === loginPath &&
					this.globalSettings.prevRoleType !== null &&
					settings.roleType !== this.globalSettings.prevRoleType;
				if (isLoginPageAndRoleChanged) {
					this.router.navigate([`/${this.globalSettings.rolePath()}/home`]);
					return false;
				}
				this.notificationService.show(
					this.translateService.instant('ExpectedRoles.RolesWarningHeader'),
					this.translateService.instant('ExpectedRoles.RolesWarningMessage'),
					{ buttonCombination: ModalKeys.Ok, icon: ModalIcon.Info }
				);
				this.router.navigate([this.router.url]);
				return false;
			}
		} else {
			this.platformLoginService.navigateToLogin({ queryParams: { returnUrl: window.location.pathname } });
			return false;
		}
	}
}
